export const INTERPRETATIONS = {
    ABOVE: 'Above',
    BENCHMARK: 'Benchmark',
    BELOW: 'Below',
    WELL_BELOW: 'Well Below',
    PAUSED: 'Paused',
    UNKNOWN: 'Unknown',
    NO_INTERPRETATION: 'No Interpretation',
    PASS: 'Pass',
    NO_PASS: 'No Pass',
};

export const TRC_INTERPRETATIONS = {
    FAR_BELOW_PROFICIENT: 'FAR_BELOW_PROFICIENT',
    BELOW_PROFICIENT: 'BELOW_PROFICIENT',
    PROFICIENT: 'PROFICIENT',
    ABOVE_PROFICIENT: 'ABOVE_PROFICIENT',
    NO_INTERPRETATION: 'NO_INTERPRETATION',
    INCOMPLETE: 'INCOMPLETE',
    UNKNOWN: 'UNKNOWN',
};

export const OL_STATUSES = {
    COMPLETED: 'COMPLETED',
    NOT_STARTED: 'NOT_STARTED',
    PAUSED: 'PAUSED',
    UNKNOWN: 'UNKNOWN',
};

export const OL_INTERPRETATIONS = {
    PROFICIENT: 'Proficient',
    BELOW_PROFICIENT: 'Below Proficient',
    SLIGHTLY_BELOW_PROFICIENT: 'Slightly Below Proficient',
};

export const D8_INTERPRETATIONS = {
    ABOVE_BENCHMARK: 'Above Benchmark',
    AT_OR_ABOVE_BENCHMARK: 'At or Above Benchmark',
    AT_BENCHMARK: 'At Benchmark',
    BELOW_BENCHMARK: 'Below Benchmark',
    WELL_BELOW_BENCHMARK: 'Well Below Benchmark',
    PAUSED: 'Paused, No Interpretation',
    UNKNOWN: 'Unknown',
};

export const LECTURA_INTERPRETATIONS = {
    ABOVE_BENCHMARK: 'Above Benchmark',
    AT_OR_ABOVE_BENCHMARK: 'At or Above Benchmark',
    AT_BENCHMARK: 'At Benchmark',
    BELOW_BENCHMARK: 'Below Benchmark',
    WELL_BELOW_BENCHMARK: 'Well Below Benchmark',
    PAUSED: 'Paused, No Interpretation',
    UNKNOWN: 'Unknown',
    WELL_BELOW: 'Well Below',
};

export const IDEL2_INTERPRETATIONS = {
    ABOVE_BENCHMARK: 'Above Benchmark',
    AT_OR_ABOVE_BENCHMARK: 'At or Above Benchmark',
    AT_BENCHMARK: 'At Benchmark',
    BELOW_BENCHMARK: 'Below Benchmark',
    WELL_BELOW_BENCHMARK: 'Well Below Benchmark',
    PAUSED: 'Paused, No Interpretation',
    UNKNOWN: 'Unknown',
    PASS: 'Pass',
    NO_PASS: 'No Pass',
};

export const INTERPRETATION_SHORT_NAME = {
    // d8
    [D8_INTERPRETATIONS.ABOVE_BENCHMARK]: INTERPRETATIONS.ABOVE,
    [D8_INTERPRETATIONS.AT_BENCHMARK]: INTERPRETATIONS.BENCHMARK,
    [D8_INTERPRETATIONS.BELOW_BENCHMARK]: INTERPRETATIONS.BELOW,
    [D8_INTERPRETATIONS.WELL_BELOW_BENCHMARK]: INTERPRETATIONS.WELL_BELOW,
    [D8_INTERPRETATIONS.PAUSED]: INTERPRETATIONS.PAUSED,
    [D8_INTERPRETATIONS.UNKNOWN]: INTERPRETATIONS.UNKNOWN,
    [D8_INTERPRETATIONS.AT_OR_ABOVE_BENCHMARK]: INTERPRETATIONS.BENCHMARK, // to support legacy results without blue cut-points

    // TRC
    [TRC_INTERPRETATIONS.ABOVE_PROFICIENT]: INTERPRETATIONS.ABOVE,
    [TRC_INTERPRETATIONS.PROFICIENT]: INTERPRETATIONS.BENCHMARK,
    [TRC_INTERPRETATIONS.BELOW_PROFICIENT]: INTERPRETATIONS.BELOW,
    [TRC_INTERPRETATIONS.FAR_BELOW_PROFICIENT]: INTERPRETATIONS.WELL_BELOW,
    [TRC_INTERPRETATIONS.INCOMPLETE]: INTERPRETATIONS.PAUSED,
    [TRC_INTERPRETATIONS.UNKNOWN]: INTERPRETATIONS.UNKNOWN,

    // OL
    [OL_INTERPRETATIONS.PROFICIENT]: INTERPRETATIONS.BENCHMARK,
    [OL_INTERPRETATIONS.BELOW_PROFICIENT]: INTERPRETATIONS.WELL_BELOW,
    [OL_INTERPRETATIONS.SLIGHTLY_BELOW_PROFICIENT]: INTERPRETATIONS.BELOW,

    // IDEL2
    [IDEL2_INTERPRETATIONS.PASS]: INTERPRETATIONS.PASS,
    [IDEL2_INTERPRETATIONS.NO_PASS]: INTERPRETATIONS.NO_PASS,
};
